import { ColorConfigSetType } from "types/ColorsTypes";
import { createPersistent } from "./store"; // I
import { appColors } from "config/colors-config";

type ColorsStoreState = {
  colorsConfigStore: ColorConfigSetType;
};

type ColorsStoreActions = {
  setColorsConfigStore: () => void;
};

const initialData: ColorsStoreState = {
  colorsConfigStore: { default: {}, light: {}, dark: {} },
};

const colorsStore = createPersistent<ColorsStoreState & ColorsStoreActions>()(
  (set, get) => ({
    ...initialData,
    setColorsConfigStore: () => {
      const root = document.documentElement;

      //** store and set for css modules */
      const colorConfigSet = appColors;
      Object.entries(colorConfigSet).forEach(([key, value]) => {
        //** standard color */
        if (typeof value === "string") {
          root.style.setProperty(`--${key}`, value);
        }
        //** color shades */
        if (typeof value === "object") {
          Object.entries(value).forEach(([keyInner, valueInner]) => {
            root.style.setProperty(`--${key}-${keyInner}`, valueInner as any);
          });
        }
      });

      set({ colorsConfigStore: colorConfigSet as ColorConfigSetType });
    },
  }),
);

export default colorsStore;
